@if (orderId) {
  <div
    class="thank-you-container"
    role="status"
    aria-live="polite"
    >
    @if (receiptError) {
      <p class="error-banner">{{ receiptError }}</p>
    }
    <!-- ===== REFUNDED VIEW ===== -->
    @if (isRefunded) {
      <section class="refunded">
        <div class="hero hero-refund">
          <div class="hero-badge">
            <span class="pulse-dot" aria-hidden="true"></span>
            <svg class="hero-icon" viewBox="0 0 24 24" aria-hidden="true">
              <!-- Check icon inside a circle -->
              <path
                d="M9 12l2 2 4-4"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <circle
                cx="12"
                cy="12"
                r="9"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              ></circle>
            </svg>
          </div>
          <h1>{{ refundCopy.title }}</h1>
          <p class="sub">
            Order <span class="mono">#{{ publicOrderCode }}</span>
          </p>
          <div class="cancel-copy">
            <p>{{ refundCopy.body }}</p>
            @if (refundReason) {
              <p class="muted">Note: {{ refundReason }}</p>
            }
            @if (refundTotalModified || refundTotalOriginal) {
              <p class="muted">
                {{
                refundTotalModified || refundTotalOriginal
                | currency: "GBP" : "symbol" : "1.2-2"
                }}
              </p>
            }
          </div>
        </div>
        <footer class="actions">
          <button class="btn btn-primary" routerLink="/menu">
            Start a new order
          </button>
          @if (lastUpdated) {
            <span class="updated" aria-live="polite">
              Updated {{ lastUpdated | date: "shortTime" }}
            </span>
          }
        </footer>
      </section>
    } @else {
      <!-- ===== CANCELLED VIEW ===== -->
      @if (isCancelled) {
        <section class="cancelled-state">
          <div class="status-shell">
            <section class="panel panel--status panel--cancelled">
              <div class="panel__header panel__header--status">
                <h2>Info</h2>
                @if (lastUpdated) {
                  <span class="status-updated" aria-live="polite">
                    Updated {{ lastUpdated | date: "shortTime" }}
                  </span>
                }
              </div>
              <div class="panel__body panel__body--status">
                <div class="status-content">
                  <h1>{{ cancelCopy.title }}</h1>
                  <p class="sub">
                    Order <span class="mono">#{{ publicOrderCode }}</span>
                  </p>
                  <div class="cancel-copy">
                    <p>{{ cancelCopy.body }}</p>
                    @if (cancelReason) {
                      <p class="status-meta">
                        <strong>Reason:</strong>
                        <span>{{ cancelReason }}</span>
                      </p>
                    }
                    @if (cancelTotalModified || cancelTotalOriginal) {
                      <p
                        class="status-meta"
                        >
                        <strong>Amount:</strong>
                        <span>
                          {{
                          cancelTotalModified || cancelTotalOriginal
                          | currency: "GBP" : "symbol" : "1.2-2"
                          }}
                        </span>
                      </p>
                    }
                  </div>
                  <div class="status-actions">
                    <button class="btn btn-primary" routerLink="/menu">
                      Start A New Order
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      } @else {
        <div class="thank-you-shell">
          <div class="thank-you-topbar">
            <button type="button" class="back-link" routerLink="/menu">
              <i class="fa-solid fa-arrow-left"></i>
              <span>Back to Menu</span>
            </button>
          </div>
          <div class="thank-you-layout">
            <section class="panel panel--main">
              <div class="panel__header">
                <h2>Order Confirmation</h2>
              </div>
              <div class="panel__body">
                <header class="hero hero--order">
                  <h1>Thanks, your order is in!</h1>
                  @if (etaFrom && etaTo) {
                    <div class="eta">
                      <div class="eta-line">
                        {{
                        orderType === "collection"
                        ? "Estimated ready between"
                        : "Estimated arrival between"
                        }}
                        <strong
                          >{{ formatTime(etaFrom) }} - {{ formatTime(etaTo) }}</strong
                          >
                        </div>
                        @if (etaCountdown) {
                          <div class="eta-countdown">
                            ~{{ etaCountdown }} remaining
                          </div>
                        }
                        <div class="chips">
                          <span class="chip">
                            <i class="fa-regular fa-clock"></i>
                            Prep: {{ prepMins.min }}-{{ prepMins.max }} min
                          </span>
                          <span class="chip">
                            <i class="fa-regular fa-clock"></i>
                            {{
                            orderType === "collection" ? "Collection" : "Delivery"
                            }}: {{ deliveryMins.min }}-{{ deliveryMins.max }} min
                          </span>
                        </div>
                      </div>
                    }
                  </header>
                  <section class="progress-card" aria-label="Order progress">
                    <div class="progress-card__header">
                      <div class="progress-card__order">
                        Order #{{ publicOrderCode }}
                      </div>
                      <button
                        type="button"
                        class="receipt-link"
                        (click)="viewReceipt()"
                        [disabled]="receiptLoading"
                        >
                        @if (!receiptLoading) {
                          View Receipt
                        } @else {
                          Loading…
                        }
                      </button>
                    </div>
                    <ol class="stepper stepper--vertical">
                      @for (step of stepsView; track step.key; let i = $index) {
                        <li
                          class="step"
                          [class.completed]="i < currentStepIndex"
                          [class.current]="i === currentStepIndex"
                          [class.pending]="i > currentStepIndex"
                          >
                          <div class="step-node">
                            @if (i < stepsView.length - 1) {
                              <div
                                class="step-rail"
                              ></div>
                            }
                            <div class="circle">
                              @if (i < currentStepIndex) {
                                <svg
                                  viewBox="0 0 24 24"
                                  class="check"
                                  aria-hidden="true"
                                  >
                                  <path
                                    d="M9 12l2 2 4-4"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                </svg>
                              }
                              @if (i === currentStepIndex) {
                                <span class="current-pulse" aria-hidden="true"></span>
                                <span class="current-dot"></span>
                              }
                            </div>
                            <div class="label">
                              <div class="title">{{ step.title }}</div>
                              @if (step.hint) {
                                <div class="hint">{{ step.hint }}</div>
                              }
                            </div>
                          </div>
                        </li>
                      }
                    </ol>
                  </section>
                </div>
              </section>
              @if (showCreateAccountPrompt) {
                <aside
                  class="panel panel--account"
                  aria-label="Create account prompt"
                  >
                  <div class="panel__header">
                    <h2>Create an account</h2>
                  </div>
                  <div class="panel__body panel__body--account">
                    <p class="account-copy">
                      Save your details for faster checkout and view your order history
                      all in one place.
                    </p>
                    <ul class="account-prompt__benefits">
                      <li>Faster checkout on future orders</li>
                      <li>View your previous orders</li>
                      <li>Keep your details in one place</li>
                    </ul>
                    <div class="account-prompt__actions">
                      <button
                        class="btn btn-outline"
                        type="button"
                        (click)="goToLogin()"
                        >
                        Log in
                      </button>
                      <button
                        class="btn btn-primary"
                        type="button"
                        (click)="goToRegister()"
                        >
                        Create Account
                      </button>
                    </div>
                  </div>
                </aside>
              }
            </div>
          </div>
        }
      }
      <!-- ===== NORMAL VIEW ===== -->
    </div>
  } @else {
    <div
      class="thank-you-container thank-you-container--missing"
      role="status"
      aria-live="polite"
      >
      <div class="status-shell">
        <section class="panel panel--status panel--missing">
          <div class="panel__header panel__header--status">
            <h2>Info</h2>
          </div>
          <div class="panel__body panel__body--status panel__body--missing">
            <div class="status-content status-content--missing">
              <h1>We couldn’t load your order</h1>
              <p class="missing-copy">
                Please open the <strong>“Track your order”</strong> link from your
                confirmation email.
              </p>
              <div class="status-actions">
                <button class="btn btn-primary" routerLink="/menu">
                  Start A New Order
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  }


@if (showReceipt && receiptOrder; as r) {
  <!-- ===== RECEIPT AXIS MODAL ===== -->
  <axis-modal
    [show]="true"
    (closed)="closeReceipt()"
    [closeOnBackdrop]="true"
    [disableEscape]="false"
    >
      <div
        class="receipt-sheet printable"
        #receiptSheet
        (click)="$event.stopPropagation()"
        >
        <header class="receipt-header">
          <div class="brand">
            <!-- <div class="brand-name">{{ tenantName || "Your Restaurant" }}</div> -->
            <div class="brand-sub">Order #{{ r.publicOrderCode }}</div>
          </div>
          <div class="receipt-actions no-print">
            <button class="btn btn-outline" (click)="printReceipt()">
              Print receipt
            </button>
            <button class="btn btn-primary" (click)="closeReceipt()">Close</button>
          </div>
        </header>
        <div class="meta-grid">
          <div><strong>Status:</strong> {{ r.orderStatus | titlecase }}</div>
          <div><strong>Payment:</strong> {{ r.paymentStatus | titlecase }}</div>
          <div><strong>Type:</strong> {{ r.orderType | titlecase }}</div>
          @if (r.orderType === 'collection' && r.orderStatus === 'delivery') {
            <div>
              <strong>Handoff:</strong> Ready for collection
            </div>
          }
          @if (r.orderType === 'delivery' && r.orderStatus === 'delivery') {
            <div>
              <strong>Handoff:</strong> Out for delivery
            </div>
          }
          <div>
            <strong>Date:</strong>
            {{ r.createdAtLocal || r.createdAt | date: "medium" }}
          </div>
          @if (r.matchedEmail) {
            <div>
              <strong>Email:</strong> {{ r.matchedEmail }}
            </div>
          }
        </div>
        @if (r.orderType === 'delivery' && r.delivery) {
          <div class="addr">
            <strong>Deliver to</strong>
            <div>
              {{ r.delivery.address_line_1 }}<br />
              @if (r.delivery.address_line_2) {
                {{ r.delivery.address_line_2 }}<br
                />
            }
            {{ r.delivery.city }}, {{ r.delivery.county }}<br />
            {{ r.delivery.postal_code }} {{ r.delivery.country }}
          </div>
        </div>
      }
      <table class="items">
        <thead>
          <tr>
            <th class="left">Item</th>
            <th>Qty</th>
            <th>Price</th>
            <th class="right">Total</th>
          </tr>
        </thead>
        <tbody>
          @for (it of r.details; track it) {
            <tr>
              <td class="left">
                <div class="item-name">{{ it.itemName }}</div>
                @if (it.itemNote) {
                  <div class="item-note">{{ it.itemNote }}</div>
                }
                @if (it.extras.length) {
                  <ul class="extras">
                    @for (ex of it.extras; track ex) {
                      <li>
                        + {{ ex?.extraName || "Extra" }}
                        @if (price(ex?.extraPrice) > 0) {
                          ({{ price(ex.extraPrice) | currency: "GBP" }})
                        }
                        @if ((ex?.extraQuantity ?? 1) > 1) {
                          × {{ ex.extraQuantity }}
                        }
                      </li>
                    }
                  </ul>
                }
              </td>
              <td class="mono">{{ it.itemQuantity }}</td>
              <td class="mono">
                {{
                price(it.itemTotalGrossOriginal) / (it.itemQuantity || 1)
                | currency: "GBP"
                }}
              </td>
              <td class="mono right">
                {{ price(it.itemTotalGrossOriginal) | currency: "GBP" }}
              </td>
            </tr>
          }
        </tbody>
        <tfoot>
          <tr class="subtotal">
            <td class="left" colspan="3">Subtotal</td>
            <td class="mono right">
              {{ receiptSubtotal | currency: "GBP" }}
            </td>
          </tr>
          @if (receiptSmallOrderFee > 0) {
            <tr class="fees">
              <td class="left" colspan="3">Small order fee</td>
              <td class="mono right">
                {{ receiptSmallOrderFee | currency: "GBP" }}
              </td>
            </tr>
          }
          @if (receiptDeliveryFee > 0) {
            <tr class="fees">
              <td class="left" colspan="3">Delivery fee</td>
              <td class="mono right">
                {{ receiptDeliveryFee | currency: "GBP" }}
              </td>
            </tr>
          }
          @if (receiptOrderFee > 0) {
            <tr class="fees">
              <td class="left" colspan="3">Service fee</td>
              <td class="mono right">
                {{ receiptOrderFee | currency: "GBP" }}
              </td>
            </tr>
          }
          <tr class="total">
            <td class="left" colspan="3">Total</td>
            <td class="mono right">
              {{ receiptTotal | currency: "GBP" }}
            </td>
          </tr>
        </tfoot>
      </table>
      @if (r.comment || r.tenantComment) {
        <div class="notes">
          @if (r.comment) {
            <div><strong>Your note:</strong> {{ r.comment }}</div>
          }
          @if (r.tenantComment) {
            <div>
              <strong>Restaurant note:</strong> {{ r.tenantComment }}
            </div>
          }
        </div>
      }
      <div class="print-footer">Thank you for your order!</div>
    </div>
  </axis-modal>
}
